<div class="cardWarning">
    <div class="content">
        EXTEND YOUR FREE TRIAL: You have {{ daysRemaining }} Days remaining. Add a credit card to maintain your network
        and receive another {{ freeTrialDays }} Days Free.
    </div>
    <button (click)="addACard()" class="save clear">Add a Card</button>
    <div (click)="closeWarning()" class="miniClose"></div>
</div>
